import { render, staticRenderFns } from "./SzsxConfig.vue?vue&type=template&id=7760f2b2"
import script from "./SzsxConfig.vue?vue&type=script&lang=js"
export * from "./SzsxConfig.vue?vue&type=script&lang=js"
import style0 from "./SzsxConfig.vue?vue&type=style&index=0&id=7760f2b2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports